import { QueryHookOptions } from '@apollo/client';
import { find } from 'lodash';
import { useRouter } from 'next/router';

import {
  useViewerQuery,
  ViewerQuery,
  ViewerQueryVariables,
  ProfileRolesFragment,
  OrganizationFieldsFragment,
} from '@/generated/graphql';

interface UseProfileResult {
  loading: boolean;
  profile?: ProfileRolesFragment & {
    organization?: OrganizationFieldsFragment | null;
  };
}

export function useProfile(
  options?: QueryHookOptions<ViewerQuery, ViewerQueryVariables>,
): UseProfileResult {
  const router = useRouter();
  const { loading, data } = useViewerQuery(options);

  const pid = router.query.pid as string;
  const profile = find(data?.viewer?.profiles ?? [], { pid });

  return { loading, profile };
}
